/**
 *
 * @description Slider Homepage Highlights Infos
 */

/* global SwiperKiller bsBreakpoints */

(() => {
	/**
	 *
	 * @description Construction du slider
	 */

	// VARS
	const root = document.querySelector('.hp-highlights-infos');
	const sk = root.querySelector('[data-sk') || null;

	// FONCTIONS

	const activateSk = () => {
		new SwiperKiller(
			'hp-highlights-infos',
			{ xl: 1, lg: 1, md: 1, sm: 1, xs: 1 },
			{
				sliderIndex: 1,
				paddingWrapper: 0,
				infinite: true,
				autoplay: 5000,
				pagination: true,
			}
		);
	};

	/**
	 * @description Fonction pour skip le slider
	 * @param slider {number}
	 */
	const skipSlider = (slider) => {
		root.querySelector(`[data-skip-slider]`).addEventListener(
			'click',
			() => {
				root.querySelector(`[data-end-slider]`).focus();
			}
		);
	};

	const moveNavigationBtns = () => {
		const next = root.querySelector('[data-next]');
		const prev = root.querySelector('[data-prev]');
		const skNav = root.querySelector('[data-sk-nav]');
		skNav.insertAdjacentElement('afterbegin', next);
		skNav.insertAdjacentElement('afterbegin', prev);
	};

	// GO 🚀
	const init = () => {
		if (sk) {
			activateSk();
			moveNavigationBtns();
			skipSlider();
		}
	};

	init();
})();
